webpackJsonp([7],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_languages_en_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_languages_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_languages_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_languages_ru_json__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_languages_ru_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_languages_ru_json__);




// Router & Store


// Languages



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = (bus);

function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
    locale: (getCookie('language') || navigator.language || navigator.userLanguage) === "ru" || (navigator.language || navigator.userLanguage) === "ru-RU" ? "ru-RU" : "en-US",
    messages: {
        'en-US': __WEBPACK_IMPORTED_MODULE_6__assets_languages_en_json___default.a['messages'],
        'ru-RU': __WEBPACK_IMPORTED_MODULE_7__assets_languages_ru_json___default.a['messages']
    },
    dateTimeFormats: {
        'en-US': __WEBPACK_IMPORTED_MODULE_6__assets_languages_en_json___default.a['dateTimeFormats'],
        'ru-RU': __WEBPACK_IMPORTED_MODULE_7__assets_languages_ru_json___default.a['dateTimeFormats']
    }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = '/api';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
    methods: {
        checkLangField: function checkLangField(field) {
            return !!field && !!field[this.$i18n.locale];
        }
    }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router_js__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* default */],
    i18n: i18n,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    saveScrollPosition: true,
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        if (to.hash) return { selector: to.hash };
        return false;
    },
    routes: [{
        path: '/',
        name: 'Main',
        component: function component(resolve) {
            __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(60)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/projects',
        name: 'Projects',
        component: function component(resolve) {
            __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(62)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/projects/:alias',
        name: 'Project',
        component: function component(resolve) {
            __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(61)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/blog',
        name: 'Blog',
        component: function component(resolve) {
            __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(57)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/blog/:alias',
        name: 'BlogPost',
        component: function component(resolve) {
            __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(58)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/studio',
        name: 'Studio',
        component: function component(resolve) {
            __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(63)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/contacts',
        name: 'Contacts',
        component: function component(resolve) {
            __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(59)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}));

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(53);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        url: "http://sota.media",
        socialImage: "",
        links: {
            main: {
                name: '$menu.main.name',
                url: '/'
            },
            projects: {
                name: '$menu.projects.name',
                url: '/projects',
                sublinks: []
            },
            blog: {
                name: '$menu.blog.name',
                url: '/blog',
                sublinks: []
            },
            studio: {
                name: '$menu.studio.name',
                url: '/studio',
                sublinks: [{ name: '$menu.studio.submenu.about', url: '/studio' }, { name: '$menu.studio.submenu.services', url: '/studio#services' }, { name: '$menu.studio.submenu.approach', url: '/studio#approach' }, { name: '$menu.studio.submenu.team', url: '/studio#team' }]
            },
            contacts: {
                name: '$menu.contacts.name',
                url: '/contacts',
                sublinks: [{ name: '$menu.contacts.submenu.touch', url: '/contacts#touch' }, { name: '$menu.contacts.submenu.location', url: '/contacts#location' }, { name: '$menu.contacts.submenu.collaboration', url: '/contacts#collaboration' }]
            },
            follow: {
                name: '$menu.follow.name',
                blank: true,
                sublinks: []
            }
        },
        contacts: {},
        developer: [{
            name: "Relocus",
            caption: "$captions.development",
            link: "http://relocus.ru"
        }, {
            name: "Maga Alkhasov",
            caption: "$captions.design",
            link: "http://maga.ws"
        }],
        category: null
    },
    mutations: {
        setCategories: function setCategories(state, obj) {
            for (var i = 0; i < obj.categories.length; i++) {
                obj.categories[i]['url'] = "/" + obj.type + "?category=" + obj.categories[i].id;
            }state.links[obj.type].sublinks = obj.categories;
        },
        setContacts: function setContacts(state, contacts) {
            state.contacts = contacts;
            state.links.follow.sublinks = contacts.social;
        },
        setSocialImage: function setSocialImage(state, imageUrl) {
            state.socialImage = state.url + imageUrl;
        },
        setCategory: function setCategory(state, category) {
            state.category = category;
        },
        clearCategory: function clearCategory(state) {
            state.category = null;
        }
    }
}));

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(42),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = {"messages":{"$menu":{"main":{"name":"Main"},"language":{"name":"Language","other":"Русский"},"projects":{"name":"Projects"},"blog":{"name":"Blog"},"studio":{"name":"Studio","submenu":{"about":"Who we are","services":"Services","approach":"Approach","team":"Team","awards":"Awards","activities":"Activities"}},"contacts":{"name":"Contacts","submenu":{"touch":"Get in touch","location":"Location on map","collaboration":"Collaboration"}},"follow":{"name":"Follow us"}},"$buttons":{"showreel":"Watch showreel","fillform":"fill in our form"},"$labels":{"feedback":"Client feedback","credits":"Credits","equipment":"Equipment","seeAlso":"See also","nextProject":"Next project","services":"We love to create","clients":"Clients","developer":"About our website","address":"Studio Address","social":"Social Media","collaboration":"Collaboration","modeling":"Modeling & Acting","map":"Show on map"},"$text":{"contacts":{"collaboration":"We are always open for new interesting offers. If you are videographer, photographer, designer or just a creative person who is striving to realize self potential, then sure to get in touch us.","modeling":"Did you ever want to be in the shot? If you still want to try yourself as a model or check acting skills, then write us.","nice":"Nice to see you here"}},"$captions":{"design":"Design","development":"Development"},"$form":{"phrase":"Please fill in the fields.\nWe will reply to you as soon as possible.","fields":{"name":{"label":"Name","placeholder":"Your name"},"contact":{"label":"Contact","placeholder":"Email or phone"},"photos":{"label":"Photos","placeholder":["Portrait","Full growth","Side"]},"comment":{"label":"Comment","placeholder":"Describe your skills..."}},"button":"Send"},"$meta":{"main":{"title":"Media and visual communications studio"},"projects":{"title":"Projects"},"blog":{"title":"Blog"},"contacts":{"title":"Contacts"},"studio":{"title":"About studio"}}},"dateTimeFormats":{"fulldate":{"year":"numeric","month":"long","day":"numeric"}}}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = {"messages":{"$menu":{"main":{"name":"Главная"},"language":{"name":"Язык","other":"English"},"projects":{"name":"Проекты"},"blog":{"name":"Блог"},"studio":{"name":"Студия","submenu":{"about":"О нас","services":"Услуги","approach":"Подход","team":"Команда","awards":"Награды","activities":"Активность и СМИ"}},"contacts":{"name":"Контакты","submenu":{"touch":"Связаться","location":"Адрес","collaboration":"Сотрудничество"}},"follow":{"name":"Мы в сети"}},"$buttons":{"showreel":"Просмотреть шоурил","fillform":"заполнения формы"},"$labels":{"feedback":"Отзыв клиента","credits":"Участники","equipment":"Оборудование","seeAlso":"Смотрите также","nextProject":"Следующий проект","services":"Любимые занятия","clients":"Клиенты","developer":"О нашем сайте","address":"Адрес студии","social":"Социальные сети","collaboration":"Сотрудничество","modeling":"Моделинг и Актерство","map":"Показать на карте"},"$text":{"contacts":{"collaboration":"Мы всегда открыты для новых интересных предложений. Если вы видеооператор, фотограф, дизайнер или просто творческий человек, стремящийся реализовать свой потенциал, то обязательно свяжитесь с нами.","modeling":"Хотели когда-нибудь оказаться в кадре? Если все еще желаете попробовать себя в качестве модели или проверить свое актерское мастерство, то напишите нам на емайл.","nice":"Будем рады встрече"}},"$captions":{"design":"Дизайн","development":"Разработка"},"$form":{"phrase":"Пожалуйста, заполните все поля. Мы свяжемся с вами.","fields":{"name":{"label":"Имя","placeholder":"Ваше имя"},"contact":{"label":"Контакты","placeholder":"Емайл или номер телефона"},"photos":{"label":"Фотографии","placeholder":["Портрет","В полный рост","Сбоку"]},"comment":{"label":"Комментарий","placeholder":"Опишите свои навыки..."}},"button":"Отправить"},"$meta":{"main":{"title":"Студия визуальных коммуникаций и медиа"},"projects":{"title":"Проекты"},"blog":{"title":"Блог"},"contacts":{"title":"Контакты"},"studio":{"title":"О студии"}}},"dateTimeFormats":{"fulldate":{"year":"numeric","month":"long","day":"numeric"}}}

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Navbar_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layouts_Navbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Footer_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Loader_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Loader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_Loader_vue__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'App',
    metaInfo: function metaInfo() {
        return {
            title: 'Page title',
            titleTemplate: '%s | Sota.',
            meta: [{ vmid: 'ogimage', property: "og:image", content: this.$store.state.socialImage }, { property: "og:locale", content: this.$i18n.locale }, { property: "og:locale:alternate", content: this.$i18n.locale == "en-US" ? "ru-RU" : "en-US" }, { property: "og:site_name", content: "Sota." }, { property: "og:see_also", content: this.$store.state.url }, { name: "twitter:site", content: "Sota." }, { name: "twitter:domain", content: this.$store.state.url }, { vmid: 'twitterimage', name: "twitter:image:src", content: this.$store.state.socialImage }]
        };
    },
    data: function data() {
        return {
            transition: {
                mode: "out-in",
                colorize: false
            },
            navbarColor: "white",
            footerColor: null,
            showLoader: false
        };
    },

    components: {
        'navbar': __WEBPACK_IMPORTED_MODULE_0__components_layouts_Navbar_vue___default.a,
        'footerbar': __WEBPACK_IMPORTED_MODULE_1__components_layouts_Footer_vue___default.a,
        'loader': __WEBPACK_IMPORTED_MODULE_2__components_layouts_Loader_vue___default.a
    },
    created: function created() {
        var _this = this;

        this.$http.get("pages/contacts").then(function (response) {
            _this.$store.commit("setContacts", response.body);
        });
        this.$http.get("pages/main").then(function (response) {
            _this.$store.commit("setSocialImage", response.body.socialImage);
        });
    },

    methods: {
        changePage: function changePage(navbarColor, footerColor) {
            this.navbarColor = navbarColor;
            this.footerColor = footerColor;
            this.showLoader = true;
        },
        endLoading: function endLoading() {
            this.showLoader = false;
        },
        colorize: function colorize(_colorize, step) {
            document.body.style.background = this.transition.colorize && _colorize ? "black" : "white";
            if (step == "end") {
                var routesName = ['Main', 'Projects', 'Project'];
                document.body.style.background = routesName.includes(this.$route.name) ? "black" : "white";
            }
        }
    },
    watch: {
        '$route': function $route(to, from) {
            var routesName = ['Main', 'Projects', 'Project'];
            this.transition.colorize = routesName.includes(to.name) && routesName.includes(from.name);
        }
    }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Input_vue__);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'file-input',
    extends: __WEBPACK_IMPORTED_MODULE_0__Input_vue___default.a,
    props: {
        extensions: {
            type: String,
            default: ""
        }
    },
    data: function data() {
        return {
            filename: ""
        };
    },

    methods: {
        updateValue: function updateValue(files) {
            this.filename = files[0].name;
            this.$emit('input', files[0]);
        },
        sFiles: function sFiles() {
            console.log("test");
            this.$refs.fileInput.click();
        }
    }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        label: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        value: {
            type: [String, File]
        }
    },
    methods: {
        updateValue: function updateValue(value) {
            this.$emit('input', value);
        }
    }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Input_vue__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'text-input',
    extends: __WEBPACK_IMPORTED_MODULE_0__Input_vue___default.a
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Input_vue__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'textarea-input',
    extends: __WEBPACK_IMPORTED_MODULE_0__Input_vue___default.a
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'footer',
    props: {
        color: {
            type: [String, Boolean],
            default: "white"
        }
    },
    computed: {
        year: function year() {
            var date = new Date();
            return date.getFullYear();
        }
    }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loader',
    props: {
        color: {
            type: String,
            default: "black"
        }
    }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_FullMenu_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_FullMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__menu_FullMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_UserForm_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_UserForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__menu_UserForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var page = __webpack_require__(32)();
var smoothScroll = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'navbar',
    props: {
        color: {
            type: String,
            default: "white"
        }
    },
    data: function data() {
        return {
            dropdownOpened: false,
            currentDropdownComponent: 'fullmenu',
            menu: ["projects", "studio", "blog", "contacts"]
        };
    },

    watch: {
        dropdownOpened: function dropdownOpened() {
            if (this.dropdownOpened) document.body.classList.add("mobile-menu-opened");else document.body.classList.remove("mobile-menu-opened");
        }
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_2__main_js__["default"].$on('open-form', this.openForm);
    },
    methods: {
        changeDropdownState: function changeDropdownState(state) {
            var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "fullmenu";

            page.hdl = this;
            this.currentDropdownComponent = component;
            if (state) {
                if (this.currentDropdownComponent == "fullmenu" || window.innerWidth > 576) document.documentElement.style.overflowY = "hidden";
                smoothScroll(0, this.currentDropdownComponent == "fullmenu" ? 50 : 200, function () {
                    page.hdl.dropdownOpened = state;
                });
            } else {
                this.dropdownOpened = state;
                document.documentElement.style.overflowY = "auto";
            }
        },
        openForm: function openForm() {
            this.changeDropdownState(true, "userform");
        }
    },
    components: {
        'fullmenu': __WEBPACK_IMPORTED_MODULE_0__menu_FullMenu_vue___default.a,
        'userform': __WEBPACK_IMPORTED_MODULE_1__menu_UserForm_vue___default.a
    }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'fullmenu',
    data: function data() {
        return {
            menu: {
                main: {
                    display: 'd-block d-sm-none'
                },
                projects: {
                    order: 'order-sm-1 order-lg-2'
                },
                blog: {
                    order: 'order-sm-1 order-lg-2'
                },
                studio: {
                    order: 'order-sm-1 order-lg-2'
                },
                contacts: {
                    order: 'order-sm-3 order-lg-2'
                },
                follow: {
                    order: 'order-sm-3 order-lg-2',
                    display: 'd-none d-sm-block'
                }
            },
            menuPaddingTop: 0
        };
    },
    created: function created() {
        var _this = this;

        this.$http.get("categories/project").then(function (response) {
            _this.$store.commit("setCategories", {
                type: "projects",
                categories: response.body
            });
        });
        this.$http.get("categories/post").then(function (response) {
            _this.$store.commit("setCategories", {
                type: "blog",
                categories: response.body
            });
        });
    },

    methods: {
        changeLanguage: function changeLanguage() {
            if (this.$i18n.locale == 'en-US') {
                this.$i18n.locale = 'ru-RU';
                this.setCookie('language', 'ru');
            } else {
                this.$i18n.locale = 'en-US';
                this.setCookie('language', 'en');
            }
        },
        close: function close() {
            this.$emit('close');
        },
        setCookie: function setCookie(name, value, options) {
            options = options || {};
            var expires = options.expires;
            if (typeof expires == "number" && expires) {
                var d = new Date();
                d.setTime(d.getTime() + expires * 1000);
                expires = options.expires = d;
            }
            if (expires && expires.toUTCString) {
                options.expires = expires.toUTCString();
            }
            value = encodeURIComponent(value);
            var updatedCookie = name + "=" + value;
            for (var propName in options) {
                updatedCookie += "; " + propName;
                var propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += "=" + propValue;
                }
            }
            document.cookie = updatedCookie;
        }
    }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_TextInput_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputs_TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inputs_TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs_FileInput_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputs_FileInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__inputs_FileInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs_TextareaInput_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs_TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__inputs_TextareaInput_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'user-form',
    data: function data() {
        return {
            formdata: {
                name: "",
                contact: "",
                photos: {
                    portrait: "",
                    fullGrowth: "",
                    side: ""
                },
                comment: ""
            }
        };
    },

    methods: {
        sendData: function sendData() {
            var formdata = new FormData();
            formdata.append('name', this.formdata.name);
            formdata.append('contact', this.formdata.contact);
            formdata.append('comment', this.formdata.comment);
            formdata.append('portrait', this.formdata.photos.portrait);
            formdata.append('fullGrowth', this.formdata.photos.fullGrowth);
            formdata.append('side', this.formdata.photos.side);
            this.$http.post("request", formdata).then(function (response) {
                console.log(response.body);
            });
            this.$emit("close");
        }
    },
    components: {
        'text-input': __WEBPACK_IMPORTED_MODULE_0__inputs_TextInput_vue___default.a,
        'file-input': __WEBPACK_IMPORTED_MODULE_1__inputs_FileInput_vue___default.a,
        'textarea-input': __WEBPACK_IMPORTED_MODULE_2__inputs_TextareaInput_vue___default.a
    }
});

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7826935e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(49),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(43),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3aec1b60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(30)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7af321ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(41),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f8153f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-sm-2"
  }, [_c('p', {
    staticClass: "text grey phrase"
  }, [_vm._v(_vm._s(_vm.$t("$form.phrase")))])]), _c('div', {
    staticClass: "col-6 col-sm-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('text-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "label": _vm.$t('$form.fields.name.label'),
      "placeholder": _vm.$t('$form.fields.name.placeholder')
    },
    model: {
      value: (_vm.formdata.name),
      callback: function($$v) {
        _vm.formdata.name = $$v
      },
      expression: "formdata.name"
    }
  }), _c('text-input', {
    staticClass: "col-6 col-sm-4",
    attrs: {
      "label": _vm.$t('$form.fields.contact.label'),
      "placeholder": _vm.$t('$form.fields.contact.placeholder')
    },
    model: {
      value: (_vm.formdata.contact),
      callback: function($$v) {
        _vm.formdata.contact = $$v
      },
      expression: "formdata.contact"
    }
  }), _c('file-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "label": _vm.$t('$form.fields.photos.label'),
      "placeholder": _vm.$t('$form.fields.photos.placeholder[0]'),
      "extensions": ".jpg, .jpeg, .png"
    },
    model: {
      value: (_vm.formdata.photos.portrait),
      callback: function($$v) {
        _vm.formdata.photos.portrait = $$v
      },
      expression: "formdata.photos.portrait"
    }
  }), _c('file-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "placeholder": _vm.$t('$form.fields.photos.placeholder[1]'),
      "extensions": ".jpg, .jpeg, .png"
    },
    model: {
      value: (_vm.formdata.photos.fullGrowth),
      callback: function($$v) {
        _vm.formdata.photos.fullGrowth = $$v
      },
      expression: "formdata.photos.fullGrowth"
    }
  }), _c('file-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "placeholder": _vm.$t('$form.fields.photos.placeholder[2]'),
      "extensions": ".jpg, .jpeg, .png"
    },
    model: {
      value: (_vm.formdata.photos.side),
      callback: function($$v) {
        _vm.formdata.photos.side = $$v
      },
      expression: "formdata.photos.side"
    }
  }), _c('textarea-input', {
    staticClass: "col-6",
    attrs: {
      "label": _vm.$t('$form.fields.comment.label'),
      "placeholder": _vm.$t('$form.fields.comment.placeholder')
    },
    model: {
      value: (_vm.formdata.comment),
      callback: function($$v) {
        _vm.formdata.comment = $$v
      },
      expression: "formdata.comment"
    }
  }), _c('div', {
    staticClass: "col-auto ml-auto"
  }, [_c('button', {
    staticClass: "main",
    on: {
      "click": _vm.sendData
    }
  }, [_vm._v(_vm._s(_vm.$t('$form.button')))])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('navbar', {
    attrs: {
      "color": _vm.navbarColor
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-page",
      "mode": "out-in"
    },
    on: {
      "before-leave": function($event) {
        _vm.colorize(true, 'begin')
      },
      "before-enter": function($event) {
        _vm.colorize(true, 'middle')
      },
      "after-enter": function($event) {
        _vm.colorize(false, 'end')
      }
    }
  }, [_c('router-view', {
    staticClass: "wrap",
    on: {
      "init": _vm.changePage,
      "end-loading": _vm.endLoading
    }
  })], 1), _c('footerbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.footerColor),
      expression: "!!footerColor"
    }],
    attrs: {
      "color": _vm.footerColor
    }
  }), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    attrs: {
      "color": _vm.navbarColor
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('label', {
    staticClass: "tech grey"
  }, [_vm._v(_vm._s(_vm.label))]), _c('textarea', {
    staticClass: "input-field",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    class: [_vm.color, {
      opened: _vm.dropdownOpened
    }]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dropdownOpened),
      expression: "!dropdownOpened"
    }],
    staticClass: "nav"
  }, [_vm._l((_vm.menu), function(key) {
    return _c('router-link', {
      key: key,
      staticClass: "menu",
      attrs: {
        "to": _vm.$store.state.links[key].url
      }
    }, [_vm._v(_vm._s(_vm.$t(_vm.$store.state.links[key].name)))])
  }), (!!_vm.$store.state.category) ? _c('span', {
    staticClass: "current-category"
  }, [_vm._v(_vm._s(_vm.$store.state.category.name[_vm.$i18n.locale]))]) : _vm._e()], 2)]), _c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    staticClass: "menu bold",
    attrs: {
      "to": _vm.$store.state.links.main.url
    },
    nativeOn: {
      "close": function($event) {
        _vm.changeDropdownState(false)
      }
    }
  }, [_vm._v("Sota.")])], 1), _c('div', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.changeDropdownState(!_vm.dropdownOpened)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 0 25 25"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.dropdownOpened) ? _c('path', {
    key: "open",
    attrs: {
      "fill": "#000",
      "fill-rule": "evenodd",
      "d": "M1 5.5h23v2H1v-2zm0 6h23v2H1v-2zm0 6h23v2H1v-2z"
    }
  }) : _c('g', {
    key: "close",
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#000",
      "stroke-width": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 5l15 15M5 20L20 5"
    }
  })])])], 1)])], 1)]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownOpened),
      expression: "dropdownOpened"
    }],
    staticClass: "dropdown",
    attrs: {
      "id": "navdropdown"
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.changeDropdownState(false)
      }
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c(_vm.currentDropdownComponent, {
    tag: "component",
    on: {
      "close": function($event) {
        _vm.changeDropdownState(false)
      }
    }
  })], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullmenu",
    style: (_vm.menuPaddingTop ? 'padding-top: ' + _vm.menuPaddingTop + 'px' : '')
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 order-sm-2 col-lg order-lg-1"
  }, [_c('h3', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.$t('$menu.language.name')))]), _c('div', {
    staticClass: "links"
  }, [_c('div', [_c('a', {
    staticClass: "menu",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.$t('$menu.language.other')))])])])]), _vm._l((_vm.menu), function(link, key) {
    return _c('div', {
      staticClass: "col-6 col-sm-2 col-lg",
      class: [link.display, link.order]
    }, [_c('h3', [(_vm.$store.state.links[key].url) ? [_c('router-link', {
      staticClass: "menu grey",
      attrs: {
        "to": _vm.$store.state.links[key].url
      },
      nativeOn: {
        "click": function($event) {
          _vm.close($event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(_vm.$store.state.links[key].name)))])] : [_vm._v(_vm._s(_vm.$t(_vm.$store.state.links[key].name)))]], 2), _c('div', {
      staticClass: "links"
    }, _vm._l((_vm.$store.state.links[key].sublinks), function(sublink) {
      return _c('div', [(_vm.$store.state.links[key].blank) ? _c('a', {
        staticClass: "menu",
        attrs: {
          "href": sublink.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(sublink.name))]) : (sublink.id) ? _c('router-link', {
        staticClass: "menu",
        attrs: {
          "to": sublink.url
        },
        nativeOn: {
          "click": function($event) {
            _vm.close($event)
          }
        }
      }, [_vm._v(_vm._s(sublink.name[_vm.$i18n.locale]))]) : _c('router-link', {
        staticClass: "menu",
        attrs: {
          "to": sublink.url
        },
        nativeOn: {
          "click": function($event) {
            _vm.close($event)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t(sublink.name)))])], 1)
    }))])
  })], 2), _c('div', {
    staticClass: "language-switch"
  }, [_c('a', {
    staticClass: "menu",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.$t('$menu.language.other')))])])])
},staticRenderFns: []}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('label', {
    staticClass: "tech grey"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "filename-input",
    on: {
      "click": _vm.sFiles
    }
  }, [_c('input', {
    staticClass: "input-field",
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.filename
    }
  }), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 25 25"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#919191",
      "stroke-width": "1.5",
      "d": "M20.948 10.809l.152-.152a4.783 4.783 0 0 0 0-6.757 4.783 4.783 0 0 0-6.757 0L3.91 14.335a4.783 4.783 0 0 0 0 6.756 4.783 4.783 0 0 0 6.756 0l7.052-7.056a2.609 2.609 0 0 0 0-3.687 2.609 2.609 0 0 0-3.687 0l-7.39 7.391"
    }
  })])]), _c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.files)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('svg', {
    staticStyle: {
      "white-space": "pre"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "shape-rendering": "geometricPrecision",
      "text-rendering": "geometricPrecision",
      "viewBox": "0 0 130 130"
    }
  }, [_c('defs', [_c('symbol', {
    attrs: {
      "id": "sota_dot",
      "preserveAspectRatio": "none",
      "width": "100",
      "height": "100",
      "viewBox": "0 0 100 100",
      "overflow": "visible"
    }
  }, [_c('rect', {
    staticStyle: {
      "animation": "a0_t 2.5s linear infinite both"
    },
    attrs: {
      "width": "100",
      "height": "100",
      "fill": _vm.color,
      "stroke": "none",
      "transform": "translate(100.5,0.5) scale(0.01,0.01) translate(-50,-50)"
    }
  })])]), _vm._v(" "), _c('use', {
    staticStyle: {
      "animation": "a1_t 2.5s linear infinite both"
    },
    attrs: {
      "width": "100",
      "height": "100",
      "xlink:href": "#sota_dot",
      "transform": "translate(80,50) translate(-50,-50)"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    class: _vm.color
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-sm order-sm-3 col-lg social"
  }, _vm._l((_vm.$store.state.links.follow.sublinks), function(link) {
    return _c('a', {
      staticClass: "menu",
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])
  })), _c('div', {
    staticClass: "col col-sm-6 order-sm-1 order-sm-1 col-lg-auto order-lg-2 contacts"
  }, [(_vm.$store.state.contacts.phone) ? _c('a', {
    staticClass: "phone menu",
    attrs: {
      "href": 'tel:' + _vm.$store.state.contacts.phone.replace(/ +/g, '')
    }
  }, [_vm._v(_vm._s(_vm.$store.state.contacts.phone))]) : _vm._e(), (_vm.$store.state.contacts.email && _vm.$store.state.contacts.email.main) ? _c('a', {
    staticClass: "email menu",
    attrs: {
      "href": 'mailto:' + _vm.$store.state.contacts.email.main
    }
  }, [_vm._v(_vm._s(_vm.$store.state.contacts.email.main))]) : _vm._e()]), _c('div', {
    staticClass: "col-6 col-sm-auto order-sm-2 col-lg-1 order-lg-1 copyright info text"
  }, [_vm._v("© " + _vm._s(_vm.year) + " Sota")])])])])
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('label', {
    staticClass: "tech grey"
  }, [_vm._v(_vm._s(_vm.label))]), _c('input', {
    staticClass: "input-field",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.86fbca04413c2905743b.js